import { render, staticRenderFns } from "./MonthlyScoreView.vue?vue&type=template&id=2b6d8cf8&"
import script from "./MonthlyScoreView.vue?vue&type=script&lang=js&"
export * from "./MonthlyScoreView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports